import { render } from "./BaseSidebarViewerBtn.vue?vue&type=template&id=3bf72f7c"
import script from "./BaseSidebarViewerBtn.vue?vue&type=script&lang=js"
export * from "./BaseSidebarViewerBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__